/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { WidgetId } from 'features/types'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getPrerequisiteWidgetForDashboard } from 'features/widget/asyncThunks'
import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import { CountTypeStrings } from 'enums/CountType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import createFingerprintSearch from './createFingerprintSearch'

const FingerprintRunSearchEffect = ({
  widgetId,
  countType,
  children
}: {
  widgetId: WidgetId
  countType: CountTypeStrings
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebStreamWidget>(widgetId)
  const dashboardData = useDashboardData() as Dashboard
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const fingerprintSearch = createFingerprintSearch(widgetSetting, dashboardData, countType)

    dispatch(
      getPrerequisiteWidgetForDashboard({
        searches: [fingerprintSearch],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, countType, dispatch, refreshTimestamp])

  return children
}

export default FingerprintRunSearchEffect
